import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import getBlog from "./blogApi";

const initialState = {
  isLoading: false,
  error: "",
  blog: {},
};
export const fetchBlog = createAsyncThunk("blog/fetchBlog", async (id) => {
  const blog = await getBlog(id);
  return blog;
});

const blogSlice = createSlice({
  name: "blog",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlog.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(fetchBlog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blog = action.payload;
      })
      .addCase(fetchBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.blog = {};
        state.error = action.error.message;
      });
  },
});
export default blogSlice.reducer;
